module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Illustrations#fm-1"
    }
  }, [_c('em', [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbreviations#fm-2"
    }
  }, [_c('em', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Preface#fm-3"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#fm-4"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_c('strong', [_vm._v("1. SYRIAC")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Ch01sec1#sec-1"
    }
  }, [_vm._v("1. The "), _c('em', [_vm._v("Doctrina Addai")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Ch01sec2#sec-2"
    }
  }, [_vm._v("2. Ephrem the Syrian, "), _c('em', [_vm._v("Hymns against Heresies 3")]), _vm._v(" and "), _c('em', [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Ch01sec3#sec-3"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("Martyrdom of Mīles, Abursam, and Sinay")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/014_Ch01sec4#sec-4"
    }
  }, [_vm._v("4. Jacob of Serugh, "), _c('em', [_vm._v("The Fourth Homily on Cain and Abel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/015_Ch01sec5#sec-5"
    }
  }, [_vm._v("5. Narsai, "), _c('em', [_vm._v("On the Canaanite Woman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/016_Ch01sec6#sec-6"
    }
  }, [_vm._v("6. Simeon of Beth Arsham, "), _c('em', [_vm._v("Letter on the")]), _vm._v(" "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _c('em', [_vm._v("imyarite Martyrs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/017_Ch01sec7#sec-7"
    }
  }, [_vm._v("7. The Syriac "), _c('em', [_vm._v("Life of Mary of Egypt")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/018_Ch01sec8#sec-8"
    }
  }, [_vm._v("8. Timothy I, "), _c('em', [_vm._v("Letter 47")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/019_Ch01sec9#sec-9"
    }
  }, [_vm._v("9. Theodore bar Koni, "), _c('em', [_vm._v("Scholion, Mēmrā 10")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2. ARMENIAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/021_Ch02sec1#sec-10"
    }
  }, [_vm._v("1. Koriwn, "), _c('em', [_vm._v("The Life of Mashtots")]), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/022_Ch02sec2#sec-11"
    }
  }, [_vm._v("2. Eznik of Koghb, "), _c('em', [_vm._v("Refutation of the Sects")]), _vm._v(" (or, "), _c('em', [_vm._v("On God")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/023_Ch02sec3#sec-12"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("The Teaching of Saint Grigor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/024_Ch02sec4#sec-13"
    }
  }, [_vm._v("4. Anania of Narek, "), _c('em', [_vm._v("On This Transitory World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/025_Ch02sec5#sec-14"
    }
  }, [_vm._v("5. Grigor of Narek, "), _c('em', [_vm._v("Book of Lamentation, Discourse 1, Discourse 88")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/026_Ch02sec6#sec-15"
    }
  }, [_vm._v("6. Nersēs Shnorhali, "), _c('em', [_vm._v("Hymn for the Sunrise Hour, Instructional Preface to a Prayer of Nersēs, Prayer of Nersēs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3. GEORGIAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/028_Ch03sec1#sec-16"
    }
  }, [_vm._v("1. Jacob C"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ʿ")]), _vm._v("urtaveli, "), _c('em', [_vm._v("Martyrdom of Saint Shushanik")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/029_Ch03sec2#sec-17"
    }
  }, [_vm._v("2. John Sabanisże, "), _c('em', [_vm._v("Martyrdom of Habo, the Perfumer from Baghdad")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/030_Ch03sec3#sec-18"
    }
  }, [_vm._v("3. George the Athonite"), _c('em', [_vm._v(",")]), _vm._v(" "), _c('em', [_vm._v("The Lives of John the Iberian and Euthymios the Athonite,")]), _vm._v(" and George the Minor, "), _c('em', [_vm._v("The Life of George the Athonite")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/031_Ch03sec4#sec-19"
    }
  }, [_vm._v("4. Mark the Deacon, "), _c('em', [_vm._v("The Life of Porphyry of Gaza")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4. ARABIC")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/033_Ch04sec1#sec-20"
    }
  }, [_vm._v("1. "), _c('em', [_vm._v("Homilies on the Gospel Readings for Holy Week")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/034_Ch04sec2#sec-21"
    }
  }, [_vm._v("2. Theodore Abū Qurrah, "), _c('em', [_vm._v("That God Is Not Weak")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/035_Ch04sec3#sec-22"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("The Disputation of Abraham of Tiberias")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/036_Ch04sec4#sec-23"
    }
  }, [_vm._v("4. "), _c('span', {
    staticClass: "f2"
  }, [_vm._v("Ḥ")]), _vm._v("unayn Ibn Is"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ḥ")]), _vm._v("āq, "), _c('em', [_vm._v("How to Discern the True Religion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/037_Ch04sec5#sec-24"
    }
  }, [_vm._v("5. "), _c('em', [_vm._v("Miracles of Saint George")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/038_Ch04sec6#sec-25"
    }
  }, [_vm._v("6. "), _c('em', [_vm._v("Commentary on the Pentateuch")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5. COPTIC")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/040_Ch05sec1#sec-26"
    }
  }, [_vm._v("1. "), _c('em', [_vm._v("Life of Pachomius")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/041_Ch05sec2#sec-27"
    }
  }, [_vm._v("2. Shenoute of Atripe, "), _c('em', [_vm._v("I Have Been Reading the Holy Gospels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/042_Ch05sec3#sec-28"
    }
  }, [_vm._v("3. Pseudo-Dioscorus of Alexandria, "), _c('em', [_vm._v("Encomium on Macarius of Tkōou")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/043_Ch05sec4#sec-29"
    }
  }, [_vm._v("4. "), _c('em', [_vm._v("The Anaphora of Saint Thomas the Apostle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/044_Ch05sec5#sec-30"
    }
  }, [_vm._v("5. Christophoria, "), _c('em', [_vm._v("Letter to the Comes Mena")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/045_Ch05sec6#sec-31"
    }
  }, [_vm._v("6. John of Paralos, "), _c('em', [_vm._v("Homily on the Archangel Michael and the Blasphemous Books of the Heretics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/046_Ch05sec7#sec-32"
    }
  }, [_vm._v("7. Pseudo-Cyril of Alexandria, "), _c('em', [_vm._v("Encomium Interpreting Part of the Apocalypse of John the Apostle of Christ Jesus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/047_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6. ETHIOPIC")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/048_Ch06sec1#sec-33"
    }
  }, [_vm._v("1. Select Inscriptions of "), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ʿ")]), _vm._v("Ezana ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/049_Ch06sec2#sec-34"
    }
  }, [_vm._v("2. "), _c('em', [_vm._v("Homily on Frumentius")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/050_Ch06sec3#sec-35"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("Synaxarion")]), _vm._v(" on Yared")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/051_Ch06sec4#sec-36"
    }
  }, [_vm._v("4. "), _c('em', [_vm._v("Glory of the Kings")]), _vm._v(" ("), _c('em', [_vm._v("K")]), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ə")]), _c('em', [_vm._v("brä Nägäśt")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/052_Ch06sec5#sec-37"
    }
  }, [_vm._v("5. "), _c('em', [_vm._v("Miracles of Mary")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/053_Ch06sec6#sec-38"
    }
  }, [_vm._v("6. Zär"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ʾ")]), _vm._v("a Ya"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ʿ")]), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ə")]), _vm._v("qob, "), _c('em', [_vm._v("Book of the Trinity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/054_Ch06sec7#sec-39"
    }
  }, [_vm._v("7. Prayer Amulet: MS Duke Ethiopic 15 ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/055_Contributors#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("List of Contributors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4290e24c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0